<div id="addCard" class="card p-3 animate__animated animate__backInDown">
  <div class="design">
    <div class="card-header p-0">
      <h5 class="title-account-setting">{{ "changePassword" | translate }}</h5>
    </div>
    <div class="card-body p-3 m-2">
      <div class="row m-0">
        <div class="d-flex justify-content-between">
          <label class="form-label" for="password">{{
            "oldPassword" | translate
          }}</label>
        </div>
        <div>
          <input
            id="oldPassword"
            #oldPasswordInput
            name="oldPassword"
            required
            minlength="8"
            maxlength="400"
            class="form-control text-start"
            dir="ltr"
            placeholder="{{ 'oldPassword' | translate }}"
            aria-describedby="oldPassword"
          />
          <div class="d-flex justify-content-between">
            <label class="form-label" for="password">{{
              "newPassword" | translate
            }}</label>
          </div>
          <div>
            <input
              id="newPassword"
              #newPasswordInput
              name="newPassword"
              required
              minlength="8"
              maxlength="400"
              class="form-control text-start"
              dir="ltr"
              placeholder="{{ 'newPassword' | translate }}"
              aria-describedby="newPassword"
            />
          </div>
          <div class="d-flex justify-content-between">
            <label class="form-label" for="password">{{
              "newPasswordAgain" | translate
            }}</label>
          </div>
          <div>
            <input
              id="confirmPassword"
              #confirmPasswordInput
              name="confirmPassword"
              required
              minlength="8"
              maxlength="400"
              class="form-control text-start"
              dir="ltr"
              placeholder="{{ 'newPasswordAgain' | translate }}"
              aria-describedby="confirmPassword"
            />
          </div>
        </div>
      </div>
      <div class="card-footer d-flex flex-row-reverse mb p-3">
        <button class="btn btn-primary d-grid w-20" type="submit"  (click)="onSubmit()">
          {{ "Save" | translate }}
        </button>
      </div>
      <app-loading-panel *ngIf="submitted"></app-loading-panel>
    </div>
  </div>
</div>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentSearchAction($event)"
>
